// extracted by mini-css-extract-plugin
export default {"container":"normal_container__cUweK","boxContainer":"normal_boxContainer__bJAxy"};